export function getNearestLocations( coordinates, locations ) {
	const [
		searchLongitude,
		searchLatitude,
	] = coordinates;

	return locations
		.filter( ( location ) => {
			return location?.geometry?.coordinates?.length >= 2;
		} )
		.map( ( location ) => {
			const [
				longitude,
				latitude,
			] = location.geometry.coordinates;

			return {
				location: location,
				distance: getDistanceInKilometers(
					searchLatitude,
					searchLongitude,
					latitude,
					longitude
				),
			};
		} )
		.sort( ( a, b ) => {
			return a.distance - b.distance;
		} )
		.slice( 0, 12 );
}

function getDistanceInKilometers(
	latitude1,
	longitude1,
	latitude2,
	longitude2
) {
	const earthRadius = 6371;

	const latitudeDelta = toRadians( latitude2 - latitude1 );

	const longitudeDelta = toRadians( longitude2 - longitude1 );

	const latitude1Radians = toRadians( latitude1 );
	const latitude2Radians = toRadians( latitude2 );

	const a = Math.sin( latitudeDelta / 2 ) *
			Math.sin( latitudeDelta / 2 ) +
			Math.cos( latitude1Radians ) *
			Math.cos( latitude2Radians ) *
			Math.sin( longitudeDelta / 2 ) *
			Math.sin( longitudeDelta / 2 );

	const c = 2 * Math.atan2(
		Math.sqrt( a ),
		Math.sqrt( 1 - a )
	);

	return earthRadius * c;
}

export function toRadians( degrees ) {
	return degrees * ( Math.PI / 180 );
}
